var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFichaDeposito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ficha-deposito",
    transform: "translate(14667 18630)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2073",
    "data-name": "Rect\\xE1ngulo 2073",
    width: 46,
    height: 46,
    transform: "translate(-14667 -18630)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21022",
    "data-name": "Grupo 21022",
    transform: "translate(-14661.958 -18624.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1392",
    "data-name": "Rect\\xE1ngulo 1392",
    d: "M2.815,1.362A1.387,1.387,0,0,0,1.407,2.724v20.56a1.387,1.387,0,0,0,1.407,1.362H33.1a1.387,1.387,0,0,0,1.407-1.362V2.724A1.387,1.387,0,0,0,33.1,1.362H2.815M2.815,0H33.1a2.771,2.771,0,0,1,2.815,2.724v20.56A2.771,2.771,0,0,1,33.1,26.008H2.815A2.771,2.771,0,0,1,0,23.284V2.724A2.771,2.771,0,0,1,2.815,0Z",
    transform: "translate(0 3.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_338",
    "data-name": "L\\xEDnea 338",
    d: "M11.645.112H-.546a.693.693,0,0,1-.7-.681.693.693,0,0,1,.7-.681H11.645a.693.693,0,0,1,.7.681A.693.693,0,0,1,11.645.112Z",
    transform: "translate(12.573 33.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1393",
    "data-name": "Rect\\xE1ngulo 1393",
    width: 22.719,
    height: 18.968,
    rx: 5,
    transform: "translate(27.535) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1393_-_Contorno",
    "data-name": "Rect\\xE1ngulo 1393 - Contorno",
    d: "M2.209,1.141A1.124,1.124,0,0,0,1.1,2.282V13.1a1.124,1.124,0,0,0,1.1,1.141h14a1.124,1.124,0,0,0,1.1-1.141V2.282a1.124,1.124,0,0,0-1.1-1.141h-14M2.209,0h14A2.246,2.246,0,0,1,18.42,2.282V13.1a2.246,2.246,0,0,1-2.209,2.282h-14A2.246,2.246,0,0,1,0,13.1V2.282A2.246,2.246,0,0,1,2.209,0Z",
    transform: "translate(25.741 6.96) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17086",
    "data-name": "Trazado 17086",
    d: "M9.036-.146H-.679A.562.562,0,0,1-1.25-.7.562.562,0,0,1-.679-1.25H9.036A.562.562,0,0,1,9.607-.7.562.562,0,0,1,9.036-.146Z",
    transform: "translate(13.846 16.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17087",
    "data-name": "Trazado 17087",
    d: "M9.036-.146H-.679A.562.562,0,0,1-1.25-.7.562.562,0,0,1-.679-1.25H9.036A.562.562,0,0,1,9.607-.7.562.562,0,0,1,9.036-.146Z",
    transform: "translate(13.846 19.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17088",
    "data-name": "Trazado 17088",
    d: "M9.036-.146H-.679A.562.562,0,0,1-1.25-.7.562.562,0,0,1-.679-1.25H9.036A.562.562,0,0,1,9.607-.7.562.562,0,0,1,9.036-.146Z",
    transform: "translate(13.846 13.766)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFichaDeposito);
export default __webpack_public_path__ + "static/media/icon-ficha-deposito.33bb1511cd62c92d01c2c4dade029063.svg";
export { ForwardRef as ReactComponent };